import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("melissa_admin_token", data.token);
      localStorage.setItem("melissa_admin_email", data.email);
      toast.success("Welcome back, Melissa.");
      nav("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login failed";
      toast.error(typeof msg === "string" ? msg : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-melissa-bg2 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-melissa-bg border border-melissa-border p-10 md:p-12">
        <Link
          to="/"
          data-testid="admin-back-home"
          className="text-[10px] uppercase tracking-overline text-melissa-inkSoft hover:text-melissa-ink"
        >
          ← Back to site
        </Link>
        <div className="mt-8 mb-10">
          <div className="w-12 h-12 rounded-full bg-melissa-ink text-melissa-bg flex items-center justify-center mb-6">
            <Lock size={18} />
          </div>
          <p className="text-xs uppercase tracking-overline text-melissa-rose mb-3">Admin Portal</p>
          <h1 className="font-serif font-light text-4xl text-melissa-ink leading-tight tracking-tight">
            Welcome back.
          </h1>
          <p className="text-sm text-melissa-inkSoft mt-2">Sign in to review inquiries & bookings.</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-5" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-[10px] uppercase tracking-overline text-melissa-inkSoft">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              placeholder="melissaruthodonnell@gmail.com"
              className="bg-melissa-bg border-melissa-border rounded-none h-12 focus-visible:ring-melissa-rose"
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="text-[10px] uppercase tracking-overline text-melissa-inkSoft">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              placeholder="••••••••"
              className="bg-melissa-bg border-melissa-border rounded-none h-12 focus-visible:ring-melissa-rose"
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full py-4 bg-melissa-ink text-melissa-bg text-xs uppercase tracking-overline hover:bg-melissa-rose transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
